export default __webpack_public_path__ + "static/media/1128040325514772.5b2a2963.jpg";